<template>
    <router-link class="pc-brand" to="/Home" :aria-label="brandName">
        <img v-if="logoUrl && !logoFailed" :src="logoUrl" :alt="brandName" @error="logoFailed = true" />
        <span v-else>{{ brandName }}</span>
    </router-link>
</template>

<script>
import { domainKey } from '@/common/http'
export default {
    data() { return { logoFailed: false } },
    computed: {
        brandName() { return this.$store.getters.sysConfig?.projectName || domainKey },
        logoUrl() { return this.$store.getters.sysConfig?.homeLogoUrl || this.$store.getters.sysConfig?.homeImageUrl }
    },
    watch: { logoUrl() { this.logoFailed = false } }
}
</script>

<style scoped>
.pc-brand { display: flex; align-items: center; gap: 6px; color: #f7f6f5; font-size: 27px; font-weight: 700; letter-spacing: -1px; text-decoration: none; }
.pc-brand img { width: 194px; max-width: 100%; height: 58px; object-fit: contain; object-position: left center; }
</style>
